module.exports = __webpack_public_path__ + "img/UA_Logo_WHT_RGB.631f193a.png";